module.exports = __webpack_public_path__ + "assets/img/W3-2-F.1ecddf26.png";